import React from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/* ═══════════════════════════════════════════
   ICONS
═══════════════════════════════════════════ */
const GridIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="1" width="6" height="6" rx="1.5" fill="currentColor"/><rect x="9" y="1" width="6" height="6" rx="1.5" fill="currentColor" opacity=".5"/><rect x="1" y="9" width="6" height="6" rx="1.5" fill="currentColor" opacity=".5"/><rect x="9" y="9" width="6" height="6" rx="1.5" fill="currentColor" opacity=".5"/></svg>;
const UsersIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M1 13c0-2.5 2.2-4.5 5-4.5s5 2 5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="12" cy="5" r="2" stroke="currentColor" strokeWidth="1.3"/><path d="M14 13c0-2-1.3-3.6-3-4.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>;
const TruckIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="5" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5"/><path d="M11 7h2l2 3v2h-4V7z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><circle cx="4" cy="13" r="1.5" fill="currentColor"/><circle cx="12" cy="13" r="1.5" fill="currentColor"/></svg>;
const TicketIcon = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="4" width="14" height="8" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M5 8h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const ChartIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M1 12l4-4 3 2 4-5 3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const LogoutIcon = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M6 2H3a1 1 0 00-1 1v10a1 1 0 001 1h3M10 11l3-3-3-3M13 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;

/* ═══════════════════════════════════════════
   STYLES BOTTOM NAV
═══════════════════════════════════════════ */
const bn = {
  bar:  { display: "none", position: "fixed", bottom: 0, left: 0, right: 0, background: "#16181f", borderTop: "0.5px solid #2a2d38", zIndex: 200, padding: "6px 0 calc(6px + env(safe-area-inset-bottom))", justifyContent: "space-around", alignItems: "center" },
  item: { display: "flex", flexDirection: "column", alignItems: "center", gap: 4, textDecoration: "none", padding: "4px 6px", borderRadius: 8, minWidth: 48 },
  icon: { width: 32, height: 32, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" },
};

/* ═══════════════════════════════════════════
   GLOBAL CSS (bottom nav responsive)
═══════════════════════════════════════════ */
const layoutCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
  @keyframes spin { to { transform: rotate(360deg); } }

  .bottom-nav { display: none; }

  @media (max-width: 992px) {
    .bottom-nav { display: flex !important; }
  }
`;

/* ═══════════════════════════════════════════
   ADMIN LAYOUT
═══════════════════════════════════════════ */
const AdminLayout = () => {
  const { logout } = useAuth();
  const location = useLocation();

  const bottomItems = [
    { to: "/admin",              icon: <GridIcon />,   label: "Dashboard"    },
    { to: "/admin/users",        icon: <UsersIcon />,  label: "Utilisateurs" },
    { to: "/admin/transporters", icon: <TruckIcon />,  label: "Transporteurs"},
    { to: "/admin/bookings",     icon: <TicketIcon />, label: "Réservations" },
    { to: "/admin/revenue",      icon: <ChartIcon />,  label: "Revenus"      },
  ];

  return (
    <div style={{ background: "#0f1117", minHeight: "100vh", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <style>{layoutCSS}</style>
      <Outlet />
      <nav style={bn.bar} className="bottom-nav">
        {bottomItems.map(({ to, icon, label }) => {
          const active = location.pathname === to;
          return (
            <Link key={to} to={to} style={{ ...bn.item, color: active ? "#4ade80" : "#8b8fa8" }}>
              <span style={{ ...bn.icon, background: active ? "rgba(74,222,128,0.12)" : "transparent" }}>
                {icon}
              </span>
              <span style={{ fontSize: 10, fontWeight: active ? 700 : 500 }}>{label}</span>
            </Link>
          );
        })}
        <button
          style={{ ...bn.item, background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", color: "#8b8fa8" }}
          onClick={logout}
        >
          <span style={bn.icon}><LogoutIcon /></span>
          <span style={{ fontSize: 10 }}>Quitter</span>
        </button>
      </nav>
    </div>
  );
};

export default AdminLayout;